import React from 'react'

import { Article, SocialMediaType } from '@/services/coin/social'

import BaseCard from './BaseCard'

type Props = {
  article: Article
}

export default function ArticleCard({ article }: Props) {
  if (!article) return null

  return <BaseCard {...article} type={SocialMediaType.Articles} />
}
